<template>
  <div>
    <modal
      name="plan-choose"
      height="auto"
      :adaptive="true"
    >
      <div class="modal-custom">
        <div>Escolha um plano 
        <i class="material-icons iconRemove" style="float: right;" @click="closeModal()" title="Fechar">close</i>
        </div><br/>
        <d-form-select type="text" name="planId" id="planId" v-model="planId">
          <option value="fitres-001">Plano mensal - R$ 30,00</option>
          <option value="fitres-002">Plano trimestral - R$ 80,00</option>
          <option value="fitres-003">Plano semestral - R$ 120,00</option>
          <option value="fitres-004">Plano anual - R$ 200,00</option>
        </d-form-select><br/><br/>
        <div style="text-align:right;" v-if="!loadingChangePlan">
          <d-button type="button" style="width: 100%;" @click="choosePlan()">Escolher plano</d-button>
        </div>
        <div style="text-align:right;" v-if="loadingChangePlan">
          <img src="/images/load2.gif" style="height: 20px;" />
        </div>
        
      </div>
    </modal>
    <d-container fluid class="main-content-container px-4">

      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
          <h3 class="page-title">Financeiro</h3>
        </div>
      </div>

      
      <!-- <d-row>
        <d-col lg="12" class="mb-4">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <h6 class="m-0">Planos</h6>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <table class="table mb-0">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Plano</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0">Início</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Plano lite</td>
                    <td>R$ 50,00 / mês</td>
                    <td>10/05/2020</td>
                    <td>Ativo</td>
                    <td>
                      <i class="material-icons iconEdit">edit</i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </d-col>
      </d-row> -->
      <d-row>
        <d-col lg="12" class="mb-4">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <h6 class="m-0" style="display: inline-block;">Planos</h6>
              <d-button type="button" style="float: right;" @click="createPlanModal()">Criar novo plano</d-button>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <table class="table mb-0">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Plano</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0">Cartão de crédito</th>
                    <th scope="col" class="border-0">Criação</th>
                    <th scope="col" class="border-0">Fatura atual</th>
                    <th scope="col" class="border-0">Próxima fatura</th>
                    <th scope="col" class="border-0">Valor</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(post, idx) in subscriptions" :key="idx" class="mb-4">
                    <td>{{getPlanName(post.plan_id)}}</td>
                    <td>{{post.status}}</td>
                    <td>{{post.fullSubscription ? post.fullSubscription.customer.billing_info.credit_card.brand + ` (XXXX-XXXX-XXXX-${post.fullSubscription.customer.billing_info.credit_card.last_four_digits})` : ''}}</td>
                    <td>{{dateBeautiful(post.date1)}}</td>
                    <td>{{post.fullSubscription && post.fullSubscription.invoice ? post.fullSubscription.invoice.status.description : ''}}</td>
                    <td>{{post.fullSubscription && post.fullSubscription.next_invoice_date ? '' + beautifulDayInvoice(post.fullSubscription.next_invoice_date.day, post.fullSubscription.next_invoice_date.month, post.fullSubscription.next_invoice_date.year) : ''}}</td>
                    <td>R$ {{post.value}}</td>
                    <td>
                      <div v-if="post.status === 'created' && post.fullSubscription">
                        <i class="material-icons iconEdit" @click="editPlanModal(post.id)" title="Editar">edit</i>
                        <i class="material-icons iconRemove" @click="removePlan(post.id)" title="Cancelar Plano">delete</i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <d-card class="card-small" >
            <div class="card-header border-bottom">
              <h6 class="m-0">Trocar cartão</h6>
            </div>
            <d-form style="padding: 15px;" @submit="checkForm">
              <h4>Cartão atual: {{user.clientComplete ? user.clientComplete.billing_info.credit_cards[0].brand + ` (XXXX-XXXX-XXXX-${user.clientComplete.billing_info.credit_cards[0].last_four_digits})` : ''}}</h4>

              <hr>
              <d-form-row>

                <!-- First Name -->
                <d-col md="12" class="form-group">
                  <label for="holderName">Nome do dono do cartão</label>
                  <d-form-input type="text" id="holderName" v-model="holderName" placeholder="Nome" />
                </d-col>

              </d-form-row>
              <d-form-row>
                <d-col md="6" class="form-group">
                  <label for="cardnumber">Número do cartão</label>
                  <d-form-input type="text" id="cardnumber" v-model="cardnumber" placeholder="Número do cartão" />
                </d-col>
                <d-col md="6" class="form-group">
                  <label for="validade">Validade (MM/YY)</label>
                  <d-form-input type="text" v-mask="'##/##'" id="validade" v-model="validade" />
                </d-col>

              </d-form-row>
              <div class="message-error" v-if="errorCustom === 1">
                Preencha todos os campos acima!
              </div>
              <div style="text-align:right;" v-if="!loading">
                <d-button type="submit" class="btn-accent">Alterar cartão</d-button>
              </div>
              <div style="text-align:right;" v-if="loading">
                <img src="/images/load2.gif" style="height: 20px;" />
              </div>
            </d-form>

          </d-card>
        </d-col>
      </d-row>
    </d-container>
  </div>
</template>
<script>
import axios from 'axios'
import config from '../config/index'
import {dateBeautiful, getPlanName, setCookie, getCookie} from '../utils'
import {mask} from 'vue-the-mask'
export default {
  name: 'payments-view',
  directives: {mask},
  data() {
    return {
      tab: 0,
      subscriptions: [],
      user: null,
      holderName: null,
      cardnumber: null,
      validade: null,
      loading: false,
      loadingChangePlan: false,
      idEditing: null
    };
  },
  beforeMount(){
    this.getData();
    this.getDataCustomer();
  },
  methods: {
    dateBeautiful,
    getPlanName,
    closeModal() {
      this.$modal.hide('plan-choose');
    },
    checkForm(e) {
      e.preventDefault();
      if (!this.holderName || !this.cardnumber || !this.validade) {
        this.errorCustom = 1;
        return false;
      }
      this.loading = true
      axios.post(config.serverUrl + '/v1/changeCreditCard',
      {
        cc_holder: this.holderName,
        cc_number: this.cardnumber,
        cc_expiration: this.validade
      }, {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        this.loading = false
        if (res.data.response) {
          alert('Dados de cartão atualizados com sucesso');
          location.reload()
        }
      })
      .catch((error) => {
        this.loading = false
        console.log(error)
      })
      return false;
    },
    beautifulDayInvoice(day, month, year) {
      return '' + day + '-' + ("0" + month).slice(-2) + '-' + year
    },
    changeCard(num) {
      this.tab = num
    },
    choosePlan() {
      if (!this.planId) {
        alert('Selecione um plano')
        return false
      }
      if (this.idEditing) {
        this.editPlan(this.idEditing)
      } else {
        this.createPlan()
      }
    },
    createPlanModal() {
      this.idEditing = null
      this.$modal.show('plan-choose');
    },
    editPlanModal(id) {
      this.idEditing = id
      this.$modal.show('plan-choose');
    },
    editPlan(id) {
      this.loadingChangePlan = true
      axios.post(config.serverUrl + '/v1/changeSubscription', {
        plan_id: this.planId,
        id: id
      },
      {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          alert('Plano alterado com sucesso')
          location.reload()
        }
      })
      .catch((error) => {
        this.loadingChangePlan = false
        console.log(error)
      })
    },
    createPlan() {
      this.loadingChangePlan = true
      axios.post(config.serverUrl + '/v1/createSubscription', {
        plan_id: this.planId
      },
      {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          alert('Plano criado com sucesso')
          location.reload()
        }
      })
      .catch((error) => {
        this.loadingChangePlan = false
        console.log(error)
      })
    },
    removePlan(id) {
      var r = confirm("Tem certeza que deseja cancelar o plano?");
      if (r == true) {
        this.cancelPlan(id)
      }
    },
    cancelPlan(id) {
      axios.post(config.serverUrl + '/v1/cancelSubscription/' + id, {}, {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          alert('Plano cancelado com sucesso')
          location.reload()
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getDataCustomer() {
      axios.get(config.serverUrl + '/v1/user', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          this.user = res.data.user
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getData() {
      axios.get(config.serverUrl + '/v1/subscriptions?page=1&limit=100', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          this.subscriptions = res.data.subscriptions
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
  },
};
</script>